module.exports = __webpack_public_path__ + "static/media/desk.61cbb171.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/room/rooms/devices/desk.png
// module id = 17
// module chunks = 0